export const BASE_URL = (function () {
    if (process.env.REACT_APP_XDOME_BASE_URL) {
        return process.env.REACT_APP_XDOME_BASE_URL;
    }

    if (process.env.NODE_ENV === 'development') {
        return "http://localhost:8080/xdome";
    }

    // return "http://xdome-staging.eba-jmbgm3yi.us-east-2.elasticbeanstalk.com/xdome";

})();

export const APP_RELEASE_STAGE = (function () {
    if (process.env.REACT_APP_RELEASE_STAGE) {
        return process.env.REACT_APP_RELEASE_STAGE;
    }

    return "development";
})();

export const APP_VERSION_NUMBER = (() => {
    const version = process.env.REACT_APP_VERSION ?? "0.0.0";
    const branch = process.env.REACT_APP_GIT_BRANCH ?? "BRANCH";
    const buildNumber = process.env.REACT_APP_BUILD_NUMBER;
    let appNumber = process.env.REACT_APP_ENVIRONMENT === "prod" ?
        `${version}:${branch}` : 
        `${version}:${branch}-${buildNumber}`

    return appNumber;
})();

export const BUGSNAG_API_KEY = (function () {
    if (process.env.REACT_APP_BUGSNAG_API_KEY) {
        return process.env.REACT_APP_BUGSNAG_API_KEY;
    }
    return "29934dc0b9c81b087b00f884e45d5dd9";
})();

export const TOKEN_KEY = "ACCESS_TOKEN";
export const PROFILE_KEY = "PROFILE";

export interface BaseAxiosResponse { }

interface Headers {
    [key: string]: string;
}

export function getHeaders() {
    let headers: Headers = {};
    if (localStorage.getItem(TOKEN_KEY) && localStorage.getItem(TOKEN_KEY) !== null) {
        headers['X-Auth-Token'] = localStorage.getItem(TOKEN_KEY)!;
    }
    headers['Content-Type'] = 'application/json';
    return headers;
}